/* Package prices and IDs come exclusively from Shopify's real variants. */
(() => {
  if (customElements.get('turbo-bundle-picker')) return;
  customElements.define('turbo-bundle-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-tb-variants]').textContent);
      this.options = JSON.parse(this.querySelector('[data-tb-options]').textContent);
      this.powerIndex = this.options.indexOf('Power');
      this.packIndex = this.options.indexOf('Package');
      this.scope = this.closest('section') || this.parentElement;
      this.scope.classList.add('tb-product');
      this.native = document.getElementById('variant-selects-' + this.dataset.section);
      this.form = document.getElementById(this.dataset.form);
      const selected = this.variants.find(v => String(v.id) === this.dataset.selected) || this.variants[0];
      this.power = selected.options[this.powerIndex];
      this.count = this.countFor(selected);
      if (!new URLSearchParams(location.search).has('variant') && this.variant(this.power, 2)?.available) this.count = 2;
      this.addEventListener('click', e => {
        const power = e.target.closest('[data-tb-power]');
        if (power) { this.power = power.dataset.tbPower; this.commit(); return; }
        if (e.target.closest('select, option, input, label')) return;
        const card = e.target.closest('[data-tb-card]');
        if (card && !card.classList.contains('tb-unavailable')) { this.count = Number(card.dataset.tbCard); this.commit(); }
      });
      this.addEventListener('change', e => {
        if (e.target.matches('[data-tb-unit]')) this.power = e.target.value;
        else if (e.target.matches('input[type=radio]')) this.count = Number(e.target.value);
        else return;
        this.commit();
      });
      this.onFormChange = e => {
        if (e.target.name !== 'id' || this.committing) return;
        const v = this.variants.find(x => String(x.id) === e.target.value);
        if (v) { this.power = v.options[this.powerIndex]; this.count = this.countFor(v); this.render(); }
      };
      this.form?.addEventListener('change', this.onFormChange);
      this.commit();
      this.startCountdown();
      const checkout = this.scope.querySelector('#opc-override-dyn-c-btn');
      if (checkout) checkout.textContent = 'CHECKOUT';
    }
    disconnectedCallback() { clearInterval(this.timer); this.form?.removeEventListener('change', this.onFormChange); this.ready = false; }
    countFor(v) { return Number((v.options[this.packIndex].match(/\d+/) || [1])[0]); }
    variant(power, count) { return this.variants.find(v => v.options[this.powerIndex] === power && this.countFor(v) === count); }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(cents / 100); }
    commit() {
      const v = this.variant(this.power, this.count);
      this.render();
      if (!v) return;
      this.committing = true;
      if (this.native) {
        const groups = this.native.querySelectorAll('.product-form__input');
        groups.forEach((group, index) => {
          const select = group.querySelector('select');
          if (select) select.value = v.options[index];
          else group.querySelectorAll('input[type=radio]').forEach(input => { input.checked = input.value === v.options[index]; });
        });
        this.native.dispatchEvent(new Event('change', {bubbles:true}));
      }
      this.committing = false;
    }
    render() {
      const single = this.variant(this.power, 1);
      this.querySelector('[data-tb-power-name]').textContent = this.power;
      this.querySelectorAll('[data-tb-power]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.tbPower === this.power));
        button.disabled = !this.variant(button.dataset.tbPower, this.count)?.available;
      });
      if (single) {
        this.querySelector('[data-tb-single]').textContent = this.money(single.price);
        this.querySelector('[data-tb-compare]').textContent = single.compare_at_price > single.price ? this.money(single.compare_at_price) : '';
        this.querySelector('[data-tb-sale]').textContent = single.compare_at_price > single.price ? Math.round((1-single.price/single.compare_at_price)*100) + '% OFF' : '';
      }
      this.querySelectorAll('[data-tb-card]').forEach(card => {
        const n = Number(card.dataset.tbCard), v = this.variant(this.power, n), selected = n === this.count;
        const radio = card.querySelector('input[type=radio]');
        radio.checked = selected;
        radio.disabled = !v?.available;
        card.classList.toggle('tb-selected', selected);
        card.classList.toggle('tb-unavailable', !v?.available);
        card.querySelector('[data-tb-total]').textContent = v ? this.money(v.price) : 'Unavailable';
        card.querySelector('[data-tb-original]').textContent = v && v.compare_at_price > v.price ? this.money(v.compare_at_price) : '';
        const each = card.querySelector('[data-tb-each]');
        if (each) each.textContent = v ? 'Only ' + this.money(Math.round(v.price/n)) + ' each' : '';
        card.querySelectorAll('[data-tb-unit]').forEach(select => {
          select.value = this.power;
          select.disabled = !v?.available;
          Array.from(select.options).forEach(option => { option.disabled = !this.variant(option.value, n)?.available; });
        });
      });
      this.querySelector('.tb-error').textContent = this.variant(this.power,this.count)?.available ? '' : 'This package is currently unavailable.';
    }
    startCountdown() {
      const end = Date.parse(this.dataset.deadline);
      if (!Number.isFinite(end)) return;
      const tick = () => {
        const left = Math.max(0, Math.ceil((end-Date.now())/1000));
        const el = this.querySelector('[data-tb-countdown]');
        el.textContent = left ? 'Hurry! Offer expires in ' + String(Math.floor(left/60)).padStart(2,'0') + ':' + String(left%60).padStart(2,'0') + ' ⏰' : 'Bundle & save on your order';
        if (!left) clearInterval(this.timer);
      };
      tick(); this.timer = setInterval(tick,1000);
    }
  });
})();
